const BRAND_VARIABLES = {
  primary_color: [
    '--brand-color',
    '--blue-9',
    '--blue-11',
    '--border-blue-strong',
    '--text-blue',
  ],
  primary_hover_color: ['--brand-hover-color', '--blue-10'],
  foreground_color: ['--brand-foreground'],
};

const targetElements = () =>
  [document.documentElement, document.body].filter(Boolean);

export const hexToRgbTriplet = color => {
  if (!/^#[0-9A-Fa-f]{6}$/.test(color || '')) return null;

  return color
    .slice(1)
    .match(/.{2}/g)
    .map(channel => Number.parseInt(channel, 16))
    .join(' ');
};

export function clearTenantBranding() {
  targetElements().forEach(element => {
    Object.values(BRAND_VARIABLES)
      .flat()
      .forEach(variable => element.style.removeProperty(variable));
  });
}

export function applyTenantBranding(branding) {
  clearTenantBranding();

  Object.entries(BRAND_VARIABLES).forEach(([field, variables]) => {
    const triplet = hexToRgbTriplet(branding?.[field]);
    if (!triplet) return;

    targetElements().forEach(element => {
      variables.forEach(variable =>
        element.style.setProperty(variable, triplet)
      );
    });
  });
}

export function useTenantBranding() {
  return { applyTenantBranding, clearTenantBranding };
}
